/** The backend request takes numeric channel IDs; chart selection uses stable series IDs. */
const MEASURE_CHANNEL_ID_PATTERN = /^measure-channel:([1-9]\d*)$/;
const MAX_MEASURE_CHANNEL_ID = 2_147_483_647;

export function getMeasureChannelIds(selectedSeriesIds: string[]): number[] {
  return selectedSeriesIds.flatMap((seriesId) => {
    const match = MEASURE_CHANNEL_ID_PATTERN.exec(seriesId);

    if (!match) {
      return [];
    }

    const channelId = Number(match[1]);
    return Number.isInteger(channelId) && channelId <= MAX_MEASURE_CHANNEL_ID ? [channelId] : [];
  });
}
